'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AutoNumeric = require('./AutoNumeric');

var _AutoNumeric2 = _interopRequireDefault(_AutoNumeric);

var _AutoNumericEvents = require('./AutoNumericEvents');

var _AutoNumericEvents2 = _interopRequireDefault(_AutoNumericEvents);

var _AutoNumericOptions = require('./AutoNumericOptions');

var _AutoNumericOptions2 = _interopRequireDefault(_AutoNumericOptions);

var _AutoNumericDefaultSettings = require('./AutoNumericDefaultSettings');

var _AutoNumericDefaultSettings2 = _interopRequireDefault(_AutoNumericDefaultSettings);

var _AutoNumericPredefinedOptions = require('./AutoNumericPredefinedOptions');

var _AutoNumericPredefinedOptions2 = _interopRequireDefault(_AutoNumericPredefinedOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-unused-vars: 0 */

/**
 * This file serve as the main entry point to the library.
 *
 * @type {AutoNumeric}
 */
exports.default = _AutoNumeric2.default; /**
                                          * Babel + Webpack workaround for autoNumeric
                                          *
                                          * @author Alexandre Bonneau <alexandre.bonneau@linuxfr.eu>
                                          * @copyright © 2017 Alexandre Bonneau
                                          *
                                          * The MIT License (http://www.opensource.org/licenses/mit-license.php)
                                          *
                                          * Permission is hereby granted, free of charge, to any person
                                          * obtaining a copy of this software and associated documentation
                                          * files (the "Software"), to deal in the Software without
                                          * restriction, including without limitation the rights to use,
                                          * copy, modify, merge, publish, distribute, sub license, and/or sell
                                          * copies of the Software, and to permit persons to whom the
                                          * Software is furnished to do so, subject to the following
                                          * conditions:
                                          *
                                          * The above copyright notice and this permission notice shall be
                                          * included in all copies or substantial portions of the Software.
                                          *
                                          * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
                                          * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
                                          * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                                          * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
                                          * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                                          * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
                                          * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
                                          * OTHER DEALINGS IN THE SOFTWARE.
                                          */

module.exports = exports['default'];